<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="width: 835px !important;">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Forma de pago {{ accion == 'facturas' ? 'de factura' : 'de recibo' }}
                        </h3>
                    </div>
                    <div :class="`col-sm-3 mt-3 ${activar_btn_guardar ? '' : 'mb-3'}`">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_de_pago === 'efectivo' ? 'btn-success' : 'btn-outline-dark']"
                            @click="set_tipo_de_pago('efectivo')"><i class="fas fa-money-bill"></i> Efectivo</button>
                    </div>
                    <div :class="`col-sm-3 mt-3 ${activar_btn_guardar ? '' : 'mb-3'}`">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_de_pago === 'tarjeta' ? 'btn-primary' : 'btn-outline-dark']"
                            @click="set_tipo_de_pago('tarjeta')"><i class="fas fa-credit-card"></i> Tarjeta</button>
                    </div>
                    <div :class="`col-sm-3 mt-3 ${activar_btn_guardar ? '' : 'mb-3'}`">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_de_pago === 'transferencia' ? 'btn-info' : 'btn-outline-dark']"
                            @click="set_tipo_de_pago('transferencia')"><i class="fas fa-exchange-alt"></i> Transferencia</button>
                    </div>
                    <div class="col-sm-3 mt-3 ">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_de_pago === 'ambos' ? 'btn-warning' : 'btn-outline-dark']"
                            @click="set_tipo_de_pago('ambos')"><i class="fas fa-money-check-alt"></i> Ambos</button>
                    </div>

                    <div v-if="tipo_de_pago == 'ambos'" class="col-sm-6 mt-3">
                        <label for="monto_efectivo" class="form-label">Monto en efectivo</label>
                        <input type="number" id="monto_efectivo" class="form-control form-control-sm"
                            v-model="monto_efectivo">
                    </div>

                    <div v-if="tipo_de_pago == 'ambos'" class="col-sm-6 mt-3">
                        <label for="monto_efectivo" class="form-label">Monto en tarjeta.</label>
                        <input type="number" readonly class="form-control form-control-sm"
                            v-model="muestra_monto_en_tarjeta">
                    </div>

                    <div v-if="tipo_de_pago == 'transferencia'" class="col-sm-12 mt-3">
                        <label for="no_transferencia" class="form-label">No. Transferencia</label>
                        <input type="text" id="no_transferencia" autocomplete="off" class="form-control form-control-sm"
                            v-model="no_transferencia">
                    </div>

                    <div v-if="tipo_de_pago == 'tarjeta' || tipo_de_pago == 'ambos'" class="col-sm-12 mt-3">
                        <label for="no_autorizacion" class="form-label">No. Autorización</label>
                        <input type="text" id="no_autorizacion" autocomplete="off" class="form-control form-control-sm"
                            v-model="no_autorizacion">
                    </div>

                    <div v-if="activar_btn_guardar" class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="guardar_datos_de_pago">Guardar</button>
                    </div>

                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import { minix } from '../functions/alertas'

    export default {
        name: 'ModalDatosDePago',
        components: {
        },
        props: ['gran_total', 'accion'],
        data() {
            return {
                tipo_de_pago: '',
                no_autorizacion: '',
                no_transferencia: '',
                monto_efectivo: 0,
                activar_btn_guardar: false,
                muestra_monto_en_tarjeta: 0
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            set_tipo_de_pago(tipo) {
                this.tipo_de_pago = tipo
                this.activar_btn_guardar = true
            },
            guardar_datos_de_pago() {
                if (this.tipo_de_pago == 'efectivo') {
                    this.set_forma_de_pago({
                        tipo_de_pago: this.tipo_de_pago,
                        no_autorizacion: this.no_autorizacion.trim()
                    })

                    if (this.accion == 'facturas') {
                        this.$emit('cerrar_y_ejecutar')
                    } else {
                        this.$emit('cerrar_y_ejecutar_recibo')
                    }

                } else if (this.tipo_de_pago == 'tarjeta') {
                    if (this.no_autorizacion.trim() != '') {
                        this.set_forma_de_pago({
                            tipo_de_pago: this.tipo_de_pago,
                            no_autorizacion: this.no_autorizacion.trim()
                        })

                        if (this.accion == 'facturas') {
                            this.$emit('cerrar_y_ejecutar')
                        } else {
                            this.$emit('cerrar_y_ejecutar_recibo')
                        }
                    } else {
                        minix({ icon: 'info', mensaje: 'Ingrese el no. autorización', tiempo: 3000 })
                    }
                } else if (this.tipo_de_pago == 'transferencia') {
                    if (this.no_transferencia.trim() != '') {
                        this.set_forma_de_pago({
                            tipo_de_pago: this.tipo_de_pago,
                            no_autorizacion: this.no_transferencia.trim()
                        })

                        if (this.accion == 'facturas') {
                            this.$emit('cerrar_y_ejecutar')
                        } else {
                            this.$emit('cerrar_y_ejecutar_recibo')
                        }
                    } else {
                        minix({ icon: 'info', mensaje: 'Ingrese el no. transferencia', tiempo: 3000 })
                    }
                } else if (this.tipo_de_pago == 'ambos') {
                    if (this.monto_efectivo <= 0 || this.monto_efectivo == '' || this.no_autorizacion.trim() == '') {
                        minix({ icon: 'info', mensaje: 'Faltan datos', tiempo: 3000 })
                    } else {

                        if (this.monto_efectivo >= this.gran_total) {
                            minix({ icon: 'info', mensaje: 'El monto en efectivo debe ser menor al total con tarjeta', tiempo: 3000 })
                        } else {

                            this.set_forma_de_pago({
                                tipo_de_pago: this.tipo_de_pago,
                                no_autorizacion: this.no_autorizacion.trim(),
                                monto_efectivo: this.monto_efectivo,
                                monto_tarjeta: this.gran_total - this.monto_efectivo
                            })

                            if (this.accion == 'facturas') {
                                this.$emit('cerrar_y_ejecutar')
                            } else {
                                this.$emit('cerrar_y_ejecutar_recibo')
                            }
                        }

                    }
                } else {
                    minix({ icon: 'info', mensaje: 'Seleccione una forma de pago', tiempo: 3000 })
                }
            },
            diferencia_de_saldos_cuando_sea_ambos() {
                let diferencia = parseFloat(this.gran_total) - parseFloat(this.monto_efectivo)
                this.muestra_monto_en_tarjeta = diferencia > 0 ? diferencia : 0
            },
            ...mapMutations(['set_forma_de_pago'])
        },
        watch: {
            monto_efectivo() {
                this.diferencia_de_saldos_cuando_sea_ambos()
            }
        }
    }
</script>

<style></style>
